var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75L8 4.75M8 4.75L6 2.75M8 4.75H6C3.79086 4.75 2 6.54086 2 8.75M18 18.75L16 20.75M16 20.75L18 22.75M16 20.75H18C20.2091 20.75 22 18.9591 22 16.75M13.4172 14.1672C14.1994 14.5408 15.0753 14.75 16 14.75C19.3137 14.75 22 12.0637 22 8.75C22 5.43629 19.3137 2.75 16 2.75C12.6863 2.75 10 5.43629 10 8.75C10 9.67472 10.2092 10.5506 10.5828 11.3328M14 16.75C14 20.0637 11.3137 22.75 8 22.75C4.68629 22.75 2 20.0637 2 16.75C2 13.4363 4.68629 10.75 8 10.75C11.3137 10.75 14 13.4363 14 16.75Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsSwap);
export default __webpack_public_path__ + "1a7f0f9bc21bf735594ceb0aeedc6663.svg";
export { ForwardRef as ReactComponent };